import type { SquareOAuthEnvironment } from "@app-rest/system/squareOAuth";
import type { StripeOAuthEnvironment } from "@app-rest/system/stripe.interfaces";
import type { IntegrationStatus } from "@app-views/square/integration/integration";

type StorageData = {
	stripeOAuth: {
		Environment: StripeOAuthEnvironment
		Redirect: string,
		Provider: string
	}
	squareOAuth: {
		Environment: SquareOAuthEnvironment,
		Redirect: string
	}
	dismissSquareTutorial: boolean,
	squareIntegrationStatus: IntegrationStatus,
	customOidcAuth: Record<string, string | boolean>,
	customBackendUrl: string
}

type StorageCategory = keyof StorageData;

export default function usePersistentStorage(storage: Storage = localStorage) {
	return {
		setItem<T extends StorageCategory>(name: T, value: StorageData[T]): void {
			storage.setItem(name, JSON.stringify(value));
		},
		getItem<T extends StorageCategory>(name: T): StorageData[T] | null {
			const item = storage.getItem(name);
			return item ? JSON.parse(item) : null;
		},
		removeItem(name: StorageCategory): void {
			storage.removeItem(name);
		}
	};
}
